<template>
  <div>
    <v-simple-table fixed-header dense>
      <thead>
        <tr>
          <th></th>
          <th class="text-left">Descripción</th>
          <th class="text-left">Referencia</th>
          <th class="text-left">Observaciones</th>
          <th class="text-center">Aplica</th>
          <th class="text-center">Compartir Sup. Ext.</th>
          <th class="text-center">Existe</th>
          <th class="text-center" width="120">F. Actualización</th>
          <th class="text-left"></th>
        </tr>
      </thead>
      <tbody>
        <!-- se crean los row de documentos por etapa -->
        <template v-for="item in listadoDocumentosExpedienteContrato">
          <tr class="text-uppercase"
          v-if="item.documentos.length > 0"
          :key="item.etapa">
            <td colspan="9" class="text-left grey lighten-3 py-2">
              <h2>{{ item.etapa }}</h2>
            </td>
          </tr>
          <!-- Se crean los row de los documentos pertenecientes a la etapa -->
          <template v-for="documento in item.documentos">
            <tr :key="documento.id">
              <!-- Si el documento tiene hijos se crea el boton para desplegarlos -->
              <td v-if="documento.childrens.length > 0" align="center" class="px-0">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      v-bind="attrs"
                      v-on="on"
                      @click="mostrarOcultar(documento)">
                      <template v-if="!documento.seEstaMostrando">
                        <v-icon>mdi-plus</v-icon>
                      </template>
                      <template v-else>
                        <v-icon>mdi-minus</v-icon>
                      </template>
                    </v-btn>
                  </template>
                  <span :id="`texto-${documento.documento.descripcion}`">Mostrar más</span>
                </v-tooltip>
              </td>
              <td v-else></td>
              <td width="35%" class="pl-1">{{ documento.documento.descripcion }}</td>
              <td>{{ documento.referencia }}</td>
              <td>{{ documento.observaciones }}</td>
              <td>
                <template>
                  <switch-aplica :expedienteDocumentoEditar="documento"> </switch-aplica>
                </template>
              </td>
              <td>
                <template>
                  <switch-compartir :expedienteDocumentoEditar="documento"> </switch-compartir>
                </template>
              </td>
              <td align="center">
                <v-tooltip v-if="documento.publicKey" top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click="verDocumentoExpediente(documento)">
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver PDF</span>
                </v-tooltip>
                <v-tooltip v-if="documento.publicKey" top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click="descargarDocumentoExpediente(documento)">
                      <v-icon
                        color="blue darken-1">
                        mdi-cloud-download
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Descargar</span>
                </v-tooltip>
              </td>
              <td>
                <template>
                  <fecha-humano :fecha="new Date(documento.updatedAt)"></fecha-humano>
                </template>
              </td>
              <td align="end" width="105">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click="editarDocumentoExpediente(documento)">
                      <v-icon
                        v-if="!documento.publicKey"
                        color="success">
                        mdi-file-plus-outline
                      </v-icon>
                      <v-icon
                        v-else
                        color="warning">
                        mdi-file-edit-outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <span v-if="!documento.publicKey">Agregar PDF</span>
                  <span v-else>Editar PDF</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click="borrarDocumentoExpediente(documento)">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Borrar</span>
                </v-tooltip>
              </td>
            </tr>
            <!-- Hijos del documento Padre -->
            <template v-if="documento.childrens.length > 0">
              <tr
                v-for="documentoHijo in documento.childrens"
                :key="documentoHijo.id"
                :class="documento.documento.descripcion"
                style="display:none"
                bgcolor="#EEEEEE">
                <td></td>
                <td><div class="pl-2">{{ documentoHijo.documento.descripcion }}</div></td>
                <td>{{ documentoHijo.referencia }}</td>
                <td>{{ documentoHijo.observaciones }}</td>
                <td>
                  <template>
                    <switch-aplica :expedienteDocumentoEditar="documentoHijo"> </switch-aplica>
                  </template>
                </td>
                <td>
                <template>
                  <switch-compartir :expedienteDocumentoEditar="documentoHijo"> </switch-compartir>
                </template>
              </td>
                <td align="center">
                  <template>
                    <tr>
                      <td>
                        <v-tooltip v-if="documentoHijo.publicKey" top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              v-bind="attrs"
                              v-on="on"
                              @click="verDocumentoExpediente(documentoHijo)"
                            >
                              <v-icon>mdi-eye</v-icon>
                            </v-btn>
                          </template>
                          <span>Ver PDF</span>
                        </v-tooltip>
                      </td>
                      <td>
                        <v-tooltip v-if="documentoHijo.publicKey" top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              v-bind="attrs"
                              v-on="on"
                              @click="descargarDocumentoExpediente(documentoHijo)"
                            >
                              <v-icon
                                color="blue darken-1">
                                mdi-cloud-download
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>Descargar</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </template>
                </td>
                <td>
                  <template>
                    <fecha-humano :fecha="new Date(documentoHijo.updatedAt)"></fecha-humano>
                  </template>
                </td>
                <td>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        @click="editarDocumentoExpediente(documentoHijo)">
                        <v-icon
                          v-if="!documento.publicKey"
                          color="success">
                          mdi-file-plus-outline
                        </v-icon>
                        <v-icon
                          v-else
                          color="warning">
                          mdi-file-edit-outline
                        </v-icon>
                      </v-btn>
                    </template>
                    <span v-if="!documentoHijo.publicKey">Agregar PDF</span>
                    <span v-else>Editar PDF</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        @click="borrarDocumentoExpediente(documentoHijo)"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Borrar</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </template>
        </template>
      </tbody>
    </v-simple-table>
    <v-dialog
        v-if="progresoDescarga"
        v-model="mostrarDescargando"
        width="200"
        persistent>
        <v-card>
          <v-card-title class="secondary--text">
            <v-row justify="center">
              Descargando
            </v-row>
          </v-card-title>
          <v-row class="pa-4" justify="center" align="center">
            <v-progress-circular
              :size="100"
              :width="15"
              :value="progresoDescarga"
              color="blue darken-1"
              dark>
              <h3>{{ progresoDescarga }}%</h3>
            </v-progress-circular>
          </v-row>
        </v-card>
      </v-dialog>
  </div>
</template>

<script>
import FechaHumano from '@/components/FechaHumano.vue';
import SwitchAplica from '@/components/administracion/expedientes/documentos/SwitchAplica.vue';
import SwitchCompartir from '@/components/administracion/expedientes/documentos/SwitchCompartir.vue';
import mixDescargarArchivo from '@/helpers/mixDescargarArchivo';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ListadoDocumentosExpedienteDesktop',
  mixins: [mixDescargarArchivo],
  props: {
    listadoDocumentosExpedienteContrato: {
      type: Array,
      required: true,
    },
  },
  components: {
    SwitchAplica,
    SwitchCompartir,
    FechaHumano,
  },
  data() {
    return {
      mostrarDescargando: false,
      progresoDescarga: null,
    };
  },
  methods: {
    mostrarOcultar(documento) {
      const textoBoton = document.getElementById(`texto-${documento.documento.descripcion}`);
      const documentoCopia = documento;
      documentoCopia.seEstaMostrando = !documentoCopia.seEstaMostrando;
      const elementos = document.getElementsByClassName(documento.documento.descripcion);
      for (let i = 0; i < elementos.length; i += 1) {
        if (elementos[i].style.display === 'none') {
          elementos[i].style = 'display:table-row;';
        } else {
          elementos[i].style = 'display:none;';
        }
      }
      if (textoBoton.innerHTML === 'Mostrar más') {
        textoBoton.innerHTML = 'Mostrar menos';
      } else {
        textoBoton.innerHTML = 'Mostrar más';
      }
    },
    editarDocumentoExpediente(documentoExpediente) {
      eventBus.$emit('editar-documento-expediente', documentoExpediente);
    },
    borrarDocumentoExpediente(documentoExpediente) {
      eventBus.$emit('borrar-documento-expediente', documentoExpediente);
    },
    verDocumentoExpediente(documentoExpediente) {
      eventBus.$emit('ver-documento-expediente', documentoExpediente);
    },
    descargarDocumentoExpediente(documentoExpediente) {
      const documento = documentoExpediente;
      const etapa = this.setEtapa(documentoExpediente.documento.etapa);
      documento.etapa = etapa;
      this.mixDescargarArchivo(documentoExpediente, 'expedientes');
    },
    setEtapa(etapa) {
      if (etapa === 1) return 'AE';
      if (etapa === 2) return 'EJ';
      if (etapa === 3) return 'DE';
      return 'N/A';
    },
    getSoloIdDocumentos(documentos) {
      return documentos.map(({ idDocumento }) => idDocumento);
    },
  },

};
</script>

<style lang="scss">
</style>
